<template>
<div class="order">
  <top-nav ref="TopNav"></top-nav>
  <!--<van-nav-bar title="订单详情" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
    <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
  <!--</van-nav-bar>-->
  <div style="padding-top: 0" class="van-content">
    <van-cell-group>
      <van-cell class="title">
        <span>{{datas.status_info.desc }}</span>
        <p class="float-right">
          <img src="/static/images/order-title1.png" v-if="datas.status_info.code == 1"/>
          <img src="/static/images/order-title1.png" v-if="datas.status_info.code == 99"/>
          <img src="/static/images/order-title2.png" v-if="datas.status_info.code == 88"/>
          <img src="/static/images/order-title3.png" v-if="datas.status_info.code == 66"/>
          <img src="/static/images/order-title4.png" v-if="datas.status_info.code == 77"/>
          <img src="/static/images/order-title5.png" v-if="datas.status_info.code == 4"/>
        </p>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <div v-if="datas.fict_order==0 || datas.fict_order==3" to="/user/mymoney" class="van-cell van-hairline sitebox">
        <i class="van-icon iconfont icon-shouhuodizhi"></i>
        <div class="van-cell__title">
          <span>收货人：{{ datas.consignee }}</span><span class="float-right">{{ datas.mobile }}</span>
          <p  class="ellipseal">收货地址：{{ datas.address_deatil }}{{ datas.address }}</p>
        </div>
      </div>
      <div v-if="datas.fict_order==1 ||datas.fict_order==2 "  class="van-cell van-hairline sitebox">
        <i style="height: 40px;line-height: 40px;" class="van-icon iconfont dianziqiaquan icon-dianziqiaquan"></i>
        <div class="van-cell__title">
          <span style=" line-height: 40px;">收货人：{{ datas.mobile }}</span>
        </div>
      </div>
    </van-cell-group>
    <van-cell-group>
      <van-card class="van-cell van-hairline goodsonelist" v-for="items in datas.product" :key="items.id">
        <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/goodslist/goods',query:{id:items.goods_id}}">
          <img :src="items.product_img" onerror="src='/static/errorimg1.png'">
        </router-link>
        <div slot="title" class="van-card-title">
          <p class="tagbox">
            <!--<span  class="theme-bg theme-bg radius" v-if="items.is_new == 1">新品</span>-->
            <!--<span class="theme-bg theme-bg radius" v-if="items.is_hot == 1">热销</span>-->
            <!--<span class="theme-bg theme-bg radius" v-if="items.is_rob == 1">限时</span>-->
            <span plain class="theme-col theme-bg radius jd" v-if="items.dummy == 3">京东</span>
          </p>
          <div class="ellipseal">
           {{ items.goods_name }}
          </div>
          <div class="theme-col">x{{items.goods_nums}}</div>
        </div>
        <div slot="desc" class="van-card-desc theme-col"><span>{{ items.goods_point }}{{ configData.integral_name }}</span></div>
        <div slot="footer">
          <!--<span class="theme-col">x{{items.goods_nums}}</span>-->
          <router-link v-if="datas.botton_info_html.logistics_show==1 && datas.cami_ser_num== ''" :to="{path:'/user/myorder/logistics',query:{expresscode:items.express_code,goodsid:items.goods_id,orderid:items.order_id}}">
            <van-button size="small" class="theme-bg theme-bd">查看物流</van-button>
          </router-link>
        </div>
      </van-card>
    </van-cell-group>
    <van-cell-group>
      <div class="van-cell van-hairline">
        <div class="van-cell__title"><span>支付方式</span></div>
        <div class="van-cell__value">
          <span v-if="datas.is_money == 0">积分</span>
          <span v-if="datas.is_money == 1">积分+现金</span>
        </div>
      </div>
      <div class="van-cell van-hairline">
        <div class="van-cell__title"><span>支付总额</span></div>
        <div class="van-cell__value theme-col"><span>{{ datas.subtotal }}{{ configData.integral_name }}</span><span v-if="datas.money_total != 0">+{{ datas.money_total }}元</span></div>
      </div>
    </van-cell-group>
    <van-cell-group>
      <van-cell>
        <p class="col-999">订单编号：{{ datas.order_sn }}</p>
        <p class="col-999">下单时间：{{ datas.add_time }}</p>
      </van-cell>
    </van-cell-group>
    <van-cell-group v-if="datas.content != ''">
      <div class="van-cell van-hairline van-field">
        <div class="van-cell__title"><span>留言</span></div>
        <div class="van-cell__value">
          <div class="text-left">{{ datas.content }}</div>
        </div>
      </div>
    </van-cell-group>
  </div>
  <van-cell-group class="botbtnbox">
    <div class="van-cell">
      <div class="text-right" style="width: 100%">
        <!-- <van-button size="small" v-if="datas.botton_info_html.delete_show == 1" @click="delOrder(datas.id)">删除订单</van-button> -->
        <van-button size="small" v-if="datas.botton_info_html.cancel_show == 1" @click="cancelOrder(datas.id)">取消订单</van-button>
        <van-button size="small" v-if="datas.cami_mi!= ''"  @click="showCardmi(datas.cami_mi,datas.cami_ka)">查看卡密</van-button>
        <van-button size="small" class="theme-bd theme-bg" v-if="datas.botton_info_html.pay_show == 1" @click="payOrder(datas.order_sn)">去支付</van-button>
        <van-button size="small" v-if="datas.botton_info_html.confirm_show == 1" class="theme-bd theme-bg" @click="confirmOrder(datas.id)">确认收货</van-button>
      </div>
    </div>
  </van-cell-group>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "order",
    components: {
      TopNav
    },
    props:['userConfig','configData'],
    data () {
      return {
        datas:'',
        id:this.$route.query.id,

      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/preview', {token:isUser,id:this.id}, res => {
          if(res.data.errCode == '0000'){
            this.datas = res.data.data.item
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
      //去支付
      payOrder: function (id) {
        var isUser = localStorage.getItem("BLHuser")
        var root = process.env.API_ROOT
        window.location.href=root+"/WebApi/JifenOrder/OrderPay/pay?"+"sn="+id+"&token="+isUser+"&payurl="+window.location.host+"/ordersucceed"
      },
      //删除订单
      delOrder: function (id) {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/delOrder', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc)
            this.goBack()
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      //取消订单
      cancelOrder: function (id) {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/cancelOrder', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc);
            this.datas.botton_info_html.pay_show = 0
            this.datas.botton_info_html.cancel_show = 0
            this.datas.botton_info_html.confirm_show = 0
            this.datas.botton_info_html.delOrder = 1
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
      //确认收货
      confirmOrder: function (id){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/confirmReceipt', {token:isUser,id:id}, res => {
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc)
            this.datas.botton_info_html.pay_show = 0
            this.datas.botton_info_html.cancel_show = 0
            this.datas.botton_info_html.confirm_show = 0
          }else if(res.data.errCode == '1002'){
            this.$dialog.confirm({
              title: '提示',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({path: '/login'})
            }).catch(() => {
              // on cancel
            });
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      showCardmi:function (mess,num) {
          var s='';
          if(num!=0){
              s='卡号:'+num
          }
        this.$dialog.confirm({
          title: '卡密信息',
          message: '卡密:'+mess+s
        })
      }
    },

    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less">
.order{
  .van-dialog .van-dialog__message{
    padding: 16px 10px;
  }
  .botbtnbox{
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
    border-top: 1px solid #f2f2f2;
    .van-cell{
      padding-top: 0;
      padding-bottom: 0;
      .van-button{
        margin: 10px 0;
      }
    }
  }
  .van-cell:not(:last-child)::after{
    left: 0;
  }
  .goodsonelist .van-card__footer{
    bottom: 8px;
  }
  .title{
    padding: 0 40px;
    background: linear-gradient(top, #ffa286, #ff5355);
    background: -webkit-gradient(linear, left top, left bottom, from(#ffa286), to(#ff5355));
    height: 100px;
    line-height: 100px;
    span{
      font-size: 2rem;
      color: #fff;
    }
    img{
      width: 80px;
    }
  }
  .van-cell-group{
    background-color: #fff;
    .wuliu .van-icon{
      line-height: 45px;
    }
    .sitebox .van-icon{
      line-height: 72px;
      font-size: 2.3rem;
      padding-right: 15px;
    }
  }
  .radius {
    padding: 0 5px 1px!important;
    -webkit-border-radius:10px 0;
    -moz-border-radius:10px 0;
    border-radius:10px 0 ;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/order.vue